import { render } from "./MonthlyContent.vue?vue&type=template&id=43d8abd8&scoped=true"
import script from "./MonthlyContent.vue?vue&type=script&lang=js"
export * from "./MonthlyContent.vue?vue&type=script&lang=js"

import "./MonthlyContent.vue?vue&type=style&index=0&id=43d8abd8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d8abd8"]])

export default __exports__